import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const baseUnitModURL = "api/v1/products-app/base-unit";
//obtaining the paginated data
export const getBaseUnit = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${baseUnitModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllBaseUnit = () => axiosInstance.get(`${baseUnitModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageBaseUnit = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${baseUnitModURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

//creating function
export const createBaseUnit = (body) => axiosInstance.post(`${baseUnitModURL}/create`, body);
//updating function
export const updateBaseUnit = (id, body) => axiosInstance.patch(`${baseUnitModURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ search, rowsPerPage, sortOrder }) =>
  axiosInstance.get(`${baseUnitModURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`);

// checking the redundant data
export const checkRedundantDataBaseUnitName = (e, cancelToken) =>
  axiosInstance.get(`${baseUnitModURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
